import * as React from 'react';
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import { DeepReadonly } from 'utility-types';
import { DotBadge } from '../DotBadge';
import { AnchorListItem } from './AnchorListItem';
import { AppName } from '@pec/aion-ui-core/interfaces/appName';
import { InlineBadge } from '../InlineBadge';
import { NavLinkListItem } from './NavLinkListItem';
import { useTranslation } from 'react-i18next';
import { IOrganization } from '@pec/aion-ui-core/interfaces/organization';

type Props = {
  navExpanded: boolean;
  notificationCount: number;
  organization: DeepReadonly<IOrganization>;
};

const { REACT_APP_NAME } = process.env;
const { AionSubcontractorManagementUI } = AppName;

export const SubcontractorManagementComponent: React.FC<Props> = ({ navExpanded, notificationCount, organization }) => {
  const showDotBadge = !navExpanded && notificationCount;
  const { t } = useTranslation();
  const organizationId = organization.id;

  return REACT_APP_NAME === AionSubcontractorManagementUI ? (
    <NavLinkListItem
      tooltip={!navExpanded}
      icon={
        showDotBadge ? (
          <DotBadge>
            <RecentActorsIcon />
          </DotBadge>
        ) : (
          <RecentActorsIcon />
        )
      }
      divider
      to={`/organizations/${organizationId}/subcontractor-management`}
    >
      {notificationCount > 0 ? (
        <InlineBadge badgeContent={notificationCount}>
          {t('components.drawerLinks.subcontractorManagement', 'Subcontractor Management')}
        </InlineBadge>
      ) : (
        t('components.drawerLinks.subcontractorManagement', 'Subcontractor Management')
      )}
    </NavLinkListItem>
  ) : (
    <AnchorListItem
      tooltip={!navExpanded}
      icon={
        showDotBadge ? (
          <DotBadge>
            <RecentActorsIcon />
          </DotBadge>
        ) : (
          <RecentActorsIcon />
        )
      }
      divider
      href={`/organizations/${organizationId}/subcontractor-management`}
    >
      {notificationCount > 0 ? (
        <InlineBadge badgeContent={notificationCount}>
          {t('components.drawerLinks.subcontractorManagement', 'Subcontractor Management')}
        </InlineBadge>
      ) : (
        t('components.drawerLinks.subcontractorManagement', 'Subcontractor Management')
      )}
    </AnchorListItem>
  );
};
